import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-attended-card',
  templateUrl: './turns-reports-attended-card.component.html',
  styleUrls: ['./turns-reports-attended-card.component.scss']
})
export class TurnsReportsAttendedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
